export const TRAINING_TYPE = {
  E_LEARNING: 'E-LEARNING',
  CLASSROOM: 'CLASSROOM',
  VIRTUAL_CLASSROOM: 'VIRTUAL CLASSROOM',
}
